class ExpenseModalController {
  constructor(AuthenticationService, $http, $uibModalInstance, $rootScope, $scope, $timeout, toastr, TravelExpenseService, items, existingExpense) {
    'ngInject';

    this.items = items;
    this.$http = $http;
    this.$uibModalInstance = $uibModalInstance;
    this.$rootScope = $rootScope;
    this.$scope = $scope;
    this.$timeout = $timeout;
    this.toastr = toastr;
    this.travelExpenseService = TravelExpenseService;

    this.editMode = !!existingExpense;
    this.originalExpense = existingExpense || null;
    this.expense = {};
    this.estimatedAmountDisplay = '';
    this.selectedFileName = null;
    this.estimateBasisFile = null;
    this.existingAttachmentName = null;

    if (this.editMode) {
      this.expense = {
        type: existingExpense.type,
        description: existingExpense.description,
        amount: existingExpense.amount,
        mileage: existingExpense.mileage
      };

      this.estimateBasisFile = existingExpense.estimateBasisFile || null;
      this.existingAttachmentName = this.travelExpenseService.getEstimateBasisLabel(existingExpense) || null;
      this.selectedFileName = existingExpense.estimateBasisFile ? existingExpense.estimateBasisFileName : null;
      this.formatEstimatedAmountDisplay();
    }

    this.$timeout(() => this.initFileSelector());
  }

  getModalTitle() {
    return this.editMode ? 'Edit Travel Expense' : 'Add Travel Expense';
  }

  getSubmitLabel() {
    return this.editMode ? 'Save Expense' : 'Add Expense';
  }

  isMileageExpense() {
    return this.expense.type === 'Personally Owned Vehicle';
  }

  getMileageRate() {
    return this.travelExpenseService.getPovMileageRate();
  }

  getMileageAmountPreview() {
    return this.travelExpenseService.calculateMileageAmount(this.expense.mileage);
  }

  formatCurrency(value) {
    return this.travelExpenseService.formatNumber(value || 0);
  }

  hasAttachment() {
    return !!(this.estimateBasisFile || this.existingAttachmentName);
  }

  onExpenseTypeChange() {
    if (this.isMileageExpense()) {
      this.expense.amount = null;
      this.estimatedAmountDisplay = '';
    } else {
      this.expense.mileage = null;
    }
  }

  initFileSelector() {
    this.fileSelector = document.getElementById('estimate-basis-file');

    if (!this.fileSelector) {
      return;
    }

    this.fileSelector.addEventListener('change', () => {
      const file = this.fileSelector.files && this.fileSelector.files[0];

      this.$scope.$apply(() => {
        this.estimateBasisFile = file || null;
        this.selectedFileName = file ? file.name : null;
      });
    });
  }

  onEstimatedAmountFocus() {
    if (this.expense.amount != null && !isNaN(this.expense.amount)) {
      this.estimatedAmountDisplay = String(this.expense.amount);
    }
  }

  onEstimatedAmountBlur() {
    this.parseEstimatedAmountDisplay();
    this.formatEstimatedAmountDisplay();
  }

  parseEstimatedAmountDisplay() {
    const raw = String(this.estimatedAmountDisplay || '').replace(/[^0-9.-]/g, '');
    const parsed = parseFloat(raw);
    this.expense.amount = isNaN(parsed) ? null : Math.round(parsed * 100) / 100;
  }

  formatEstimatedAmountDisplay() {
    if (this.expense.amount == null || isNaN(this.expense.amount)) {
      this.estimatedAmountDisplay = '';
      return;
    }

    this.estimatedAmountDisplay = this.travelExpenseService.formatNumber(this.expense.amount);
  }

  clearSelectedFile() {
    this.estimateBasisFile = null;
    this.selectedFileName = null;

    if (this.fileSelector) {
      this.fileSelector.value = '';
    }
  }

  addTravelRelatedExpense() {
    if (!this.expense.type) {
      this.toastr.warning('Select an expense type.', 'Incomplete');
      return;
    }

    if (!this.expense.description || !this.expense.description.trim()) {
      this.toastr.warning('Enter a description for this expense.', 'Incomplete');
      return;
    }

    let expenseToSave;

    if (this.isMileageExpense()) {
      const mileage = parseFloat(this.expense.mileage);

      if (isNaN(mileage) || mileage <= 0) {
        this.toastr.warning('Enter estimated mileage greater than zero.', 'Incomplete');
        return;
      }

      if (!this.hasAttachment()) {
        this.toastr.warning('Upload a screenshot of your map route as mileage evidence.', 'Evidence Required');
        return;
      }

      const roundedMileage = Math.round(mileage * 10) / 10;

      expenseToSave = {
        type: this.expense.type,
        description: this.expense.description.trim(),
        mileage: roundedMileage,
        amount: this.travelExpenseService.calculateMileageAmount(roundedMileage)
      };
    } else {
      this.parseEstimatedAmountDisplay();

      if (this.expense.amount == null || isNaN(this.expense.amount) || this.expense.amount <= 0) {
        this.toastr.warning('Enter a valid estimated amount greater than zero.', 'Incomplete');
        return;
      }

      expenseToSave = {
        type: this.expense.type,
        description: this.expense.description.trim(),
        amount: this.expense.amount,
        mileage: null
      };
    }

    expenseToSave.estimateBasisFile = this.estimateBasisFile;
    expenseToSave.estimateBasisFileName = this.selectedFileName || this.existingAttachmentName;

    if (this.editMode) {
      this.$uibModalInstance.updateExpenseInReport(this.originalExpense, expenseToSave);
    } else {
      this.$uibModalInstance.addExpenseToReport(expenseToSave);
    }

    this.$uibModalInstance.dismiss('success');
  }

  cancel() {
    this.$uibModalInstance.dismiss('cancel');
  }
}

export default ExpenseModalController;



// WEBPACK FOOTER //
// ./client/pages/expenses/modals/travel-expense-type/travel-expense-type.controller.js